<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div
        class="container-fluid d-flex align-items-center vld-parent"
        ref="startups_list"
      >
        <div class="row d-flex justify-content-between">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Confira a lista de todas as startups inscritas no processo de
              seleção da Stars, separadas em três grupos. Após visualizar as
              informações da startup, você pode preencher a ficha de avaliação e
              deixar comentários.
            </p>
          </div>
          <div class="float-right">
            <base-button @click="showFilter = !showFilter">
              filtrar
            </base-button>
          </div>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--8">
      <div class="row">
        <div class="col-12">
          <tabs
            fill
            :centered="true"
            class="flex-column flex-md-row"
            tabNavWrapperClasses="pt-0"
            type="primary"
            :value="control.tab"
            @newActiveTab="loadStartups"
          >
            <tab-pane title="g1">
              <span slot="title"> Grupo 1 </span>
            </tab-pane>
            <tab-pane title="g2">
              <span slot="title"> Grupo 2 </span>
            </tab-pane>
            <tab-pane title="g3">
              <span slot="title"> Grupo 3 </span>
            </tab-pane>
          </tabs>
        </div>
        <div class="col-12 mt-5" v-if="!empty">
          <div class="card-deck">
            <div
              class="col-lg-3 col-md-6 mb-5 d-flex align-items-stretch"
              v-for="startup in startups"
              :key="startup.user_id"
            >
              <div class="card text-center flex-grow-1">
                <div class="card-profile-image">
                  <img
                    :src="startup.logo.url"
                    class="card-image my-3"
                    alt="..."
                  />
                </div>
                <div class="card-body mt-7 pt-4 pt-0 pb-0">
                  <h2 class="card-title text-orange mb-1">
                    {{ startup.name }}
                  </h2>
                  <div>
                    <div class="h5 font-weight-300 mb-1">
                      <i class="ni ni-pin-3 mr-2"></i
                      >{{ startup.city || "..." }},
                      {{ startup.state || "..." }}
                    </div>
                    <div class="h5 mt-2 mr-1">
                      <badge
                        type="info"
                        v-for="sector in startup.sector.split(',')"
                        :key="'sector_' + sector"
                      >
                        {{ sector }}
                      </badge>
                    </div>
                  </div>
                </div>
                <div
                  class="card-footer d-flex align-items-center justify-content-center"
                  style="height: 60px; cursor: pointer"
                  @click="
                    handleGoToEvaluation(
                      startup.evaluation_id,
                      startup.subscription_id
                    )
                  "
                >
                  <p
                    :class="[
                      {
                        'text-success': isAlreadyEvaluated(
                          startup.subscription_id
                        ),
                      },
                      'mt-3 font-weight-500',
                    ]"
                  >
                    <i class="fas fa-edit mr-1" title="Avaliação"></i>
                    {{
                      isAlreadyEvaluated(startup.subscription_id)
                        ? "já avaliada"
                        : "avaliar startup"
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 text-center mt-3" v-else>
          <badge type="info" class="bg-white">
            Nenhuma startup disponível para avaliação no momento.
          </badge>
        </div>
      </div>
    </div>
    <right-sidebar
      v-if="showFilter"
      @close="showFilter = false"
      icon="fas fa-filter"
      title="Filtrar Exibição"
    >
      <div class="col-12 mb-4">
        <h3 class="text-center">Filtrar por segmento de atuação:</h3>
      </div>
      <v-select
        multiple
        class="sector_select"
        placeholder="Busque por um setor"
        label="title"
        :options="startup_sector"
        v-model="filter.selectedSectors"
      >
        <template v-slot:option="option">
          <i class="fa fa-tag mr-2"></i>
          {{ option.title }}
          <span class="float-right text-xs"> </span>
        </template>
      </v-select>
      <div class="d-flex justify-content-center">
        <base-button class="btn-md mt-4" @click="loadStartups()">
          Aplicar filtro
        </base-button>
      </div>
    </right-sidebar>
  </div>
</template>
<script>
import api from "@/services/api";
import RightSidebar from "@/components/RightSidebar";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
export default {
  name: "startups_list",
  components: {
    RightSidebar,
    "v-select": vSelect,
  },
  data() {
    return {
      startups: [],
      subscriptionsAlreadyEvaluated: [],
      empty: false,
      control: {
        tab: "g1",
        scrollX: 0,
        scrollY: 0,
      },
      filter: {
        selectedSectors: [],
      },
      showFilter: false,
      startup_sector: [
        "Aeroespacial",
        "Agricultura",
        "Alimentos e bebidas",
        "Biotecnologia",
        "Computadores e periféricos",
        "Construção",
        "Consultoria",
        "Dispositivos e equipamentos médicos",
        "Educação",
        "Eletrônica/instrumentação",
        "Esportes",
        "Estilo de vida",
        "Imóveis",
        "Indústria/energia",
        "Internet/serviços da web",
        "Jogos",
        "Jurídico",
        "Marketing digital",
        "Marketing/publicidade",
        "Marítimo",
        "Mineração",
        "Moda",
        "Mídias e entretenimento",
        "Nanotecnologia",
        "Náutica/Navegação",
        "Petróleo e gás",
        "Produtos da empresa",
        "Produtos de consumo",
        "Redes e equipamentos",
        "Robótica",
        "Segurança",
        "Semicondutores",
        "Serviços a empresas",
        "Serviços ao consumidor",
        "Serviços de saúde",
        "Serviços de TI",
        "Serviços financeiros",
        "Serviços móveis",
        "Software",
        "Substâncias e produtos químicos",
        "Tecnologia limpa",
        "Tecnologia para finanças",
        "Telecomunicações",
        "Transportes",
        "Turismo",
        "Varejo/distribuição",
        "Outro",
      ],
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      container: this.$refs.startups_list,
      width: 150,
      height: 150,
      color: "#341d4a",
      backgroundColor: "transparent",
    });
    this.control.tab = this.$route.query.grupo || "g1";
    await this.loadEvaluations();
    await this.loadStartups(this.control.tab, loader);

    let { scrollX, scrollY } = this.$route.query;
    if (scrollX || scrollY) {
      this.control.scrollX = scrollX || 0;
      this.control.scrollY = scrollY || 0;
      window.scrollTo(this.control.scrollX, this.control.scrollY);
    }
  },
  methods: {
    handleGoToEvaluation(evaluation_id, subscription_id) {
      this.handleSaveScrollPos();
      const toURL = `/investidor/avaliacoes/${evaluation_id}/inscricoes/${subscription_id}/avaliar?cb=${this.control.tab}&scrollX=${this.control.scrollX}&scrollY=${this.control.scrollY}`;
      this.$router.push(toURL);
    },

    handleSaveScrollPos() {
      let { scrollX, scrollY } = window;
      this.control.scrollX = scrollX;
      this.control.scrollY = scrollY;
    },

    async loadStartups(tab, loaderObj) {
      this.empty = false;
      const loader = loaderObj
        ? loaderObj
        : this.$loading.show({
            container: this.$refs.startups_list,
            width: 150,
            height: 150,
            color: "#341d4a",
            backgroundColor: "transparent",
          });

      try {
        let url = `/investor-evaluations/${this.$route.params.id}?tab=${tab}`;
        if (this.filter.selectedSectors.length) {
          url += `&sectors=${this.filter.selectedSectors.join(",")}`;
        }
        const { data: startups } = await api.get(url);
        const defaultLogoPath = "/img/pages/default_logo.png";
        if (startups.length) {
          startups.forEach((startup) => {
            if (!startup.logo) startup.logo = { url: defaultLogoPath };
          });
          this.startups = startups;
        } else this.empty = true;
        this.control.tab = tab;
      } catch (e) {
        this.$toasted.error(
          "Ocorreu um erro ao recuperar as startups para a avaliação"
        );
      } finally {
        loader.hide();
      }
    },
    async loadEvaluations() {
      try {
        const { data } = await api.get(
          `/investor-evaluations/${this.$route.params.id}/responses`
        );
        this.subscriptionsAlreadyEvaluated = data.map((e) => e.subscription_id);
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao recuperar as informações");
      }
    },
    isAlreadyEvaluated(subscriptionId) {
      return this.subscriptionsAlreadyEvaluated.includes(subscriptionId);
    },
  },
};
</script>
<style scoped>
.card-image {
  width: 140px;
  height: 140px;
  border-radius: 10%;
  margin: auto;
}

.sector_select.v-select {
  background-color: #fff;
  background-clip: padding-box;
}

.sector_select.v-select .vs__dropdown-toggle {
  padding: 0.5rem 0.1rem;
  min-width: 100%;
}

.sector_select.v-select .vs__dropdown-toggle .vs__selected-options .vs__search {
  color: #8898aa;
  font-weight: 400;
  line-height: 1.5;
  font-size: 0.875rem;
}
</style>
